<!-- <app-navbar></app-navbar> -->

<main>
  <section id="page_main">
    <div id="squared_year">
      <img src="../../../assets/imagens/fourty_year_logo.svg" alt="" />

      <h1 id="text_celebrations">
        Mais de <span class="number">40</span> anos de inovação contínua em
        colaboração com a <span class="nowrap"> PUC-Rio</span>.
      </h1>
    </div>

    <div id="img_building_puc">
      <img src="../../../assets/imagens/Azul_PUC_Arredor.png" alt="" />
    </div>
  </section>

  <section id="page_second">
    <div class="foundation_history text_and_media">
      <div class="text title_foundation">
        <h1 id="foundation">A Fundação</h1>
        <div class="text_foundation">
          <p class="paragraph_foundation_history">
            A Fundação Padre Leonel Franca (FPLF) foi instituída em 1983, com a
            missão de proporcionar maior dinamismo no estabelecimento de
            relações contratuais, visando o atendimento de interesses da
            sociedade, em sintonia com os propósitos da Pontifícia Universidade
            Católica do Rio de Janeiro (PUC-Rio). É uma instituição autônoma,
            sem fins lucrativos, vinculada à Universidade, que amplifica o
            impacto positivo da academia na sociedade e vice-versa.
          </p>

          <p class="paragraph_foundation_history">
            A Fundação articula projetos e coordena a gestão de contratos de
            relevante retorno técnico, científico e sociocultural. Na realização
            de suas atividades, está habilitada a relacionar-se com outras
            instituições semelhantes de natureza pública e privada, sendo
            credenciada junto a diversos órgãos de fomento à pesquisa,
            desenvolvimento e inovação.
          </p>

          <p class="paragraph_foundation_history">
            Sediada no Campus da PUC-Rio, no bairro da Gávea, na cidade do Rio
            de Janeiro, beneficia-se da infraestrutura de um moderno parque
            tecnológico, de laboratórios de pesquisa em diferentes áreas de
            conhecimento e da excelência de pesquisadores, mestres e doutores da
            Universidade. Sua estrutura orgânica permite agilidade na
            contratação e articulação de projetos de PD&I (Pesquisa,
            Desenvolvimento e Inovação) com Instituições Privadas e com a
            Administração Pública, executados pela PUC-Rio.
          </p>

          <p class="paragraph_foundation_history">
            Ao longo de quatro décadas, a Fundação Padre Leonel Franca atuou na
            gestão de mais de 3.000 projetos de elevada importância acadêmica.
            Acumula uma longa tradição e experiência na execução de tarefas que
            exijam excelência científica e tecnológica. Ao logo dos 40 anos de
            história da FPLF em torno de 10.000 pessoas, diretamente ligadas aos
            seus projetos, vêm escrevendo sua história e tecendo sonhos e
            realidades.
          </p>
        </div>

        <button
          routerLink="/foundation"
          id="button_know_more"
          mat-flat-button
          color="accent"
        >
          <a class="know_more">Saiba mais</a>
        </button>
      </div>

      <div class="media">
        <img
          id="img_foudation"
          src="../../../assets/imagens/fundacao_building.png"
          alt=""
        />
      </div>
    </div>
  </section>

  <section id="third_page">
    <div class="institutional_history text_and_media">
      <div class="text">
        <h1 id="institutional">Institucional</h1>

        <div class="text_institutional">
          <p class="history_padre_leonal">
            A PUC-Rio conta com o apoio da Fundação Padre Leonel Franca como
            catalizadora do desenvolvimento institucional, científico e
            tecnológico, trazendo mais agilidade, facilidade e segurança
            jurídica às pesquisas produzidas.
          </p>

          <p class="history_padre_leonal">
            Cabe a FPLF a gestão administrativa e financeira de contratos, que
            engloba atividades administrativas como avaliação legal da
            documentação e um conjunto de processos e estratégias que garantem
            eficiência, controle dos contratos e evita riscos que possam ocorrer
            durante as etapas.
          </p>

          <p class="history_padre_leonal">
            Assim, a FPLF atua, há 40 anos (dede 1983), junto à PUC-Rio, com
            responsabilidade, transparência e dedicação, na melhoria da execução
            de projetos das mais diversas áreas do ensino, pesquisa e extensão.
          </p>
        </div>

        <!-- <button
        routerLink="/foundation"
        id="button_know_more"
        mat-flat-button
        color="accent"
      >
        <a class="know_more">Saiba mais</a>
      </button> -->
      </div>

      <div class="media">
        <img
          id="img_priest"
          src="../../../assets/imagens/padre_leonal.png"
          alt=""
        />
      </div>
    </div>
  </section>

  <section id="fourth_page">
    <div class="puc_rio_history text_and_media">
      <div class="text">
        <h1 id="puc_rio">A Puc-Rio</h1>

        <div class="text_university_rio">
          <p class="puc_rio_university">
            A Pontifícia Universidade Católica do Rio de Janeiro é uma
            instituição comunitária de Educação Superior, de acordo com Portaria
            679, de 12/11/2014, da Secretaria de Regulação e Supervisão da
            Educação Superior, filantrópica e sem fins lucrativos, que visa
            produzir e propagar o saber a partir das atividades de ensino,
            pesquisa e extensão, tendo por base o pluralismo e debates
            democráticos, objetivando, sobretudo, a reflexão, o crescimento e
            enriquecimento da sociedade.
          </p>

          <p class="puc_rio_university">
            A internacionalização do ensino e o intercâmbio entre culturas e
            saberes são propostas acolhidas pela PUC-Rio diante de um mundo
            globalizado. O campus, construído em uma área de 104 mil metros
            quadrados, permite a integração entre cursos e possibilita o
            desenvolvimento de projetos multidisciplinares. A PUC-Rio busca a
            excelência na pesquisa, no ensino e na extensão para a formação de
            profissionais competentes, habilitados ao pleno desempenho de suas
            funções.
          </p>

          <p class="puc_rio_university">
            O decreto que autorizou o funcionamento das Faculdades Católicas foi
            publicado em 30 de outubro de 1940, pelo então presidente Getúlio
            Vargas, em resposta a Dom Sebastião Leme, após criação da Associação
            Civil Faculdades Católicas. Em dezembro do mesmo ano, padre Leonel
            Franca, S.J., assume as funções de Reitor das Faculdades Católicas.
            As atividades dos primeiros cursos, Direito e Filosofia, iniciaram
            em março de 1941. A partir de então, Padre Franca e seus
            colaboradores trabalharam para estruturar a Escola de Serviço
            Social, o que permitiu a constituição da Universidade Católica, em
            15 de janeiro de 1946, por meio do Decreto 8.681. Em 20 de janeiro
            do ano seguinte, por um Decreto da Congregação dos Seminários, a
            Universidade recebeu o título de Pontifícia.
          </p>
        </div>
      </div>

      <div class="media">
        <img
          id="img_puc_rio"
          src="../../../assets/imagens/puc_rio.png"
          alt=""
        />
      </div>
    </div>
  </section>

  <!-- <section id="fifth_page">
    <div class="conclusion_foundation text_and_media">
      <div class="text">
        <img
          class="foundation_priest_logo"
          src="../../../assets/imagens/logo_foundation_2.svg"
          alt=""
        />

        <div class="conclusion_text">
          <p class="conclusion">
            A Pontifícia Universidade Católica do Rio de Janeiro ( PUC-Rio) está
            situada no bairro da Gávea, zona sul da cidade. Primeira
            universidade da América Latina a instalar um computador de grande
            porte, ainda na década de 60. Hoje, é uma das que mais desenvolve
            pesquisa no Brasil.
          </p>

          <p class="conclusion">
            O modelo da PUC-Rio procura integrar a graduação com pós-graduação,
            pesquisa e extensão, incentivando no aluno o gosto pela pesquisa
            desde o início de sua formação. Em seus departamentos são oferecidos
            vários cursos de mestrado e doutorado, todos com conceito A ou B da
            CAPES.
          </p>
        </div>
      </div>

      <div class="img_Puc_logo media">
        <img
          id="img_university_rio"
          src="../../../assets/imagens/Azul_PUC_Arredor.png"
          alt=""
        />
        <img
          id="img_logo_university"
          src="../../../assets/imagens/logo_priest.svg"
          alt=""
        />
      </div>
    </div>
  </section> -->
</main>

<!-- <app-footer></app-footer> -->
